import axiosInstance from '../axios'
import axios from 'axios'
import { rejectError } from '../helper'

const transformRequest = (jsonData = {}) => Object.entries(jsonData)
  .map((x) => `${encodeURIComponent(x[0])}=${encodeURIComponent(x[1])}`)
  .join('&')

export default {
  state: {
    token: null,
    username: null,
    user: null,
  },
  mutations: {
    setToken (state, token) {
      state.token = token
    },
    setUsername (state, username) {
      state.username = username
    },
    storeUser (state, user) {
      state.user = user
    },
    clearAuthData (state) {
      state.token = null
      state.username = null
      state.user = null
    },
  },
  getters: {
    user (state) {
      return state.user
    },
    isAuthenticated (state) {
      return state.token !== null
    },
    getUsername (state) {
      return state.username
    },
  },
  actions: {
    // eslint-disable-next-line no-unused-vars
    login ({ commit, dispatch }, data) {
      const args = {
        username: data.username,
        password: data.password,
      }
      return axiosInstance.post('/api/v1/authorize', transformRequest(args), {
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      })
        .then((res) => {
          localStorage.setItem('token', res.data.data)
          return commit('setToken', res.data.data)
        })
        .catch((error) => rejectError(error))
    },
    checkToken ({ commit, dispatch }, token) {
      const params = {}
      const headers = {
        'X-Access-Token': token,
      }
      return axios.get('/api/v1/users/me', {
        params,
        headers,
      })
        .then(() => {
          localStorage.setItem('token', token)
          commit('setToken', token)
          return dispatch('fetchUser')
        })
        .catch((error) => {
          commit('clearAuthData')
          return rejectError(error)
        })
    },
    // eslint-disable-next-line no-unused-vars
    changeMyPassword ({ dispatch }, password) {
      return axiosInstance({
        method: 'POST',
        url: '/api/v1/users/me/commands/change-password',
        data: { password },
      })
        .then((result) => result.data.data)
        .catch((error) => Promise.reject(error))
    },
    // eslint-disable-next-line no-unused-vars
    updateUser ({ dispatch }, user) {
      return axiosInstance({
        method: 'PATCH',
        url: '/api/v1/users/me',
        data: user,
      })
        .then((result) => result.data.data)
        .catch((error) => Promise.reject(error))
    },
    fetchUser ({ commit, state }) {
      if (!state.token) {
        return
      }
      axiosInstance.get('/api/v1/users/me?$expand=*')
        .then((res) => {
          const user = res.data.data
          commit('storeUser', user)
          commit('setUsername', user.username)
          localStorage.setItem('username', user.username)
        })
        .catch((error) => rejectError(error))
    },
    // eslint-disable-next-line no-unused-vars
    logout ({ commit }) {
      commit('clearAuthData')
      localStorage.removeItem('token')
      localStorage.removeItem('calendarInterval')
    },
    // eslint-disable-next-line no-unused-vars
    tryAutoLogin ({ commit, state, dispatch }) {
      const token = localStorage.getItem('token')
      if (!token) {
        commit('clearAuthData')
        return
      }
      commit('setToken', token)
      const username = localStorage.getItem('username')
      if (!username) {
        dispatch('fetchUser')
        return
      }
      if (!state.user) {
        dispatch('fetchUser')
      } else {
        commit('setUsername', username)
      }
    },
  },
}
